import React from "react";
import { Plus } from "lucide-react";
import { Button } from "@/components/ui/button";

interface AdsHeaderProps {
  openAddDialog: () => void;
}

const AdsHeader: React.FC<AdsHeaderProps> = ({ openAddDialog }) => {
  return (
    <div className="flex justify-between items-center">
      <div>
        <h1 className="text-3xl font-bold tracking-tight">Anuncios</h1>
        <p className="text-muted-foreground">
          Gestiona tus anuncios en las pantallas de forma fácil. También puedes añadir el enlace del material asociado a tus anuncios.
        </p>
      </div>
      <Button onClick={openAddDialog}>
        <Plus className="mr-1 h-4 w-4" /> Ir a Facturación
      </Button>
    </div>
  );
};

export default AdsHeader;
